import { FC } from 'react';

import VideoModal from 'src/components/common/modal/videoModal';

const RateCardOtherInformationModal: FC = () => (
    <VideoModal videoUrl="https://www.youtube.com/watch?v=no4zMk70Oio&ab_channel=apadua" />
);

export default RateCardOtherInformationModal;
